import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { AppDispatch, AppThunk, RootState } from '../../store';
import {
	getUserdataError,
	getUserdataInit,
	getUserdataSuccess,
	logOutError,
	logOutInit,
	logOutSuccess,
	resetPasswordError,
	resetPasswordInit,
	resetPasswordSuccess
} from '../../store/slices/authSlice';
import { METHOD, apiCall } from '../services/api/baseApiCall';
import {
	LOGOUT_URL,
	RESET_PASSWORD_URL,
	USER_DATA_URL,
	VERIFYTOKEN
} from '../services/apiEndPoint';

export const logOut = (): ThunkAction<void, RootState, undefined, Action> => dispatch => {
	dispatch(logOutInit());

	apiCall(
		`${LOGOUT_URL}`,
		{},
		(data: any) => {
			dispatch(logOutSuccess(data));
		},
		() => {
			dispatch(logOutError());
		},
		METHOD.DELETE,
		{ showToast: true }
	);
	// dispatch(logoutsucess());
};

// export const logoutsucess = () => (dispatch: AppDispatch) => {
// 	toast.success('logout successfully');

// 	dispatch(logOutSuccess());
// };

export const getUserData = (): AppThunk => (dispatch: AppDispatch) => {
	dispatch(getUserdataInit());

	apiCall(
		USER_DATA_URL,
		{ deviceType: 3 },
		(data: any) => {
			dispatch(getUserdataSuccess(data));
		},
		() => {
			dispatch(getUserdataError());
			dispatch(logOutSuccess());
		},
		METHOD.GET,
		{}
	);
};

export const resetPassword =
	(password: any, id: string): AppThunk =>
	(dispatch: AppDispatch) => {
		// dispatch(resetPasswordInit());

		return new Promise<void>((resolve, reject) => {
			apiCall(
				`${RESET_PASSWORD_URL}`,
				{ password, id },
				() => {
					dispatch(resetPasswordSuccess());
					resolve(); // Resolve the promise with the data returned from the API call
				},
				(error: any) => {
					dispatch(resetPasswordError());
					reject(error); // Reject the promise with the error from the API call
				},
				METHOD.PUT,
				{ showToast: true }
			);
		});
	};

export const varifyToken =
	(token: any): AppThunk =>
	(dispatch: AppDispatch) => {
		dispatch(resetPasswordInit());

		return new Promise<any>((resolve, reject) => {
			apiCall(
				`${VERIFYTOKEN}?token=${token}`,
				{},
				(data: any) => {
					console.log(data);
					const id = data?.data?.id;
					const email = data?.data?.email;
					dispatch(resetPasswordSuccess());
					resolve({ id, email }); // Resolve the promise with the data returned from the API call
				},
				() => {
					dispatch(resetPasswordError());
					reject(''); // Reject the promise with the error from the API call
				},
				METHOD.GET,
				{ showToast: true }
			);
		});
	};
// export const logOutJWT =
// 	(): ThunkAction<void, RootState, undefined, Action> => dispatch => {
// 		dispatch(logOutInit());
// 		dispatch(logoutsucessJWT());
// 	};

// export const logoutsucessJWT = () => (dispatch: AppDispatch) => {
// 	toast.success('logout successfully');
// 	dispatch(logOutSuccess());
// };
